const STORAGE_KEY = 'editorMode';

/**
 * Read the persisted editor-mode flag so it survives navigating between pages.
 * @returns {boolean}
 */
export const getPersistedEditorMode = () => {
    try {
        return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (error) {
        return false;
    }
};

/**
 * Persist the editor-mode flag so the next page mount picks it back up.
 * @param {boolean} mode
 */
export const setPersistedEditorMode = (mode) => {
    try {
        localStorage.setItem(STORAGE_KEY, mode ? 'true' : 'false');
    } catch (error) {
        // Ignore storage errors (e.g. private browsing / storage disabled).
    }
};
